import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'src/app/core/services/message.service';
import { MatDialog } from '@angular/material';
import { PreMerchandiseLocationComponent } from '../pre-merchandise-location/pre-merchandise-location.component';
import { ModalPdfComponent } from '../modal-pdf/modal-pdf.component';

@Component({
  selector: 'app-pre-merchandise',
  templateUrl: './pre-merchandise.component.html',
  styleUrls: ['./pre-merchandise.component.scss']
})
export class PreMerchandiseComponent implements OnInit {
  form: FormGroup;
  submitted: boolean;
  unitMessure: string;
  location: number;
  product: string;
  productSaved: boolean;
  bult: string;
  quantity = 0;

  constructor(private formBuilder: FormBuilder, private messageService: MessageService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.unitMessure = 'PZA';
    this.location = 0;

    this.form = this.formBuilder.group({
      bulto: ['', Validators.required],
      producto: ['', Validators.required],
      cantidad: ['', [Validators.required, Validators.min(1)]],
      um: ['', Validators.required]
    });

    this.cleanData();
  }

  get controls() { return this.form.controls; }

  onSave() {
    this.submitted = true;
    this.controls.bulto.markAsTouched();
    this.controls.producto.markAsTouched();
    this.controls.cantidad.markAsTouched();
    this.controls.um.markAsTouched();

    if (this.form.invalid) {
      return;
    } else {
      this.productSaved = true;
      this.messageService.success('Éxito', 'El número de parte se relacionó al producto');
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      // this.messageService.error('Error', '*Campos Obligatorios*');
      return;
    } else {
      this.cleanData();
      this.messageService.success('Éxito', 'El bulto se ha cerrado');
    }
  }

  openLocation() {
    console.log('Opening modal');
    const dialogRef = this.dialog.open(PreMerchandiseLocationComponent, {
      width: '600px',
      height: '250px',
      data: {location: this.location}
    });

    dialogRef.afterClosed().subscribe(() => {
      this.messageService.success('Éxito', 'La ubicación se ha guardado correctamente');
    });
  }

  openFotography(): void {
    this.openDialog();
  }

  private openDialog(): void {
    const dialogRef = this.dialog.open(ModalPdfComponent, {
        height: '600px',
        width: '600px',
        data: { title: 'Tomar fotografía', url: '/assets/pdf/Fotografia.jpeg' }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.messageService.success('Éxito', 'Las fotografías se han guardado correctamente');
    });
  }

  cleanData() {
    this.bult = '';
    this.product = '';
    this.quantity = 0;
    this.location = 0;
    this.productSaved = false;

    this.form.reset({
      unitMessure: 'PZA'
    });

    this.unitMessure = 'PZA';
  }

  onLoadProduct(): void {
    if (!this.bult) {
      return;
    }

    if (this.bult === '0000100OPS22454') {
      this.product = 'NP-0032253';
    } else {
      this.product = '';
      this.messageService.error('Error', 'No se ha encontrado el bulto');
    }
  }

}
